import { render, staticRenderFns } from "./NumberSettings.vue?vue&type=template&id=589715f0&"
import script from "./NumberSettings.vue?vue&type=script&lang=js&"
export * from "./NumberSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports